import Component from '@ember/component';

/*
  attrs
  - goal
  - fund
*/
export default Component.extend({
  classNames: ['row'],
});
